import {PriceStrategy} from "../input/PriceStrategy";

export const PriceStrategyValuePrecisionFilter = "tfStrategyValuePrecisionFormat";

export function priceStrategyValuePrecisionFilter() {
    return (input: number | null, strategy: PriceStrategy, precision?: number) => {
        if (input == null || strategy == null) {
            return null;
        } else {
            return strategy.formatValueExtraPrecision(input, precision);
        }
    };
}
